<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 safetyApp">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            ref="gofixTable">
                            <template slot="gofix_table:planned_date" slot-scope="row">
                                {{row.item.started_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:updated_at" slot-scope="row">
                                {{row.item.updated_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Toolbox Meeting" 
            hide-footer 
            :centered="true" 
            size="lg"
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <dropdown-projects
                            ref="dropdownProjects"
                            @setDefaultValue="setDefaultProject"
                            v-model="modals.add.data.project">
                        </dropdown-projects>
                        <!-- <dropdown-locations 
                            label="Locations"
                            required
                            show-icon-required
                            multiple
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            v-model="modals.add.data.locations">
                        </dropdown-locations> -->
                        <dropdown-locations 
                            label="Location"
                            required
                            show-icon-required
                            :isUpsertLocation="isUpsertLocation"
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            v-model="modals.add.data.equipment">
                        </dropdown-locations>
                        <!-- <gofix-form-dropdown
                            label="Topics"
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.topics"
                            :options="modals.add.options.topics">
                        </gofix-form-dropdown> -->
                        <gofix-form-dropdown
                            label="Work Tasks"
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.work_tasks"
                            :options="modals.add.options.work_tasks">
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea
                            v-if="hasOthers(modals.add.data.work_tasks)"
                            label="Please specify (Work Tasks - Others)"
                            required
                            show-icon-required
                            :rows="4"
                            v-model="modals.add.data.work_tasks_other_text">
                        </gofix-form-input-textarea>
                        <gofix-form-dropdown
                            label="Hazards"
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.hazards"
                            :options="modals.add.options.hazards">
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea
                            v-if="hasOthers(modals.add.data.hazards)"
                            label="Please specify (Hazards - Others)"
                            required
                            show-icon-required
                            :rows="4"
                            v-model="modals.add.data.hazards_other_text">
                        </gofix-form-input-textarea>
                        <gofix-form-dropdown
                            label="Safe Work Procedure"
                            vLabel="reference_value_text"
                            required
                            show-icon-required
                            multiple
                            v-model="modals.add.data.safe_work_procedures"
                            :options="modals.add.options.safe_work_procedures">
                        </gofix-form-dropdown>
                        <gofix-form-input-textarea
                            v-if="hasOthers(modals.add.data.safe_work_procedures)"
                            label="Please specify (Safe Work Procedure - Others)"
                            required
                            show-icon-required
                            :rows="4"
                            v-model="modals.add.data.safe_work_procedure_other_text">
                        </gofix-form-input-textarea>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-textarea
                                    label="Work Task For The Day"
                                    :rows="4"
                                    v-model="modals.add.data.work_task_for_the_day">
                                </gofix-form-input-textarea>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-textarea
                                    label="Hazards Identified"
                                    :rows="4"
                                    v-model="modals.add.data.hazards_identified">
                                </gofix-form-input-textarea>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-textarea
                                    label="Mitigation Of Hazard"
                                    :rows="4"
                                    v-model="modals.add.data.mitigation_of_hazard">
                                </gofix-form-input-textarea>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-textarea
                                    label="Feedback From Worker(s)"
                                    :rows="4"
                                    v-model="modals.add.data.feedback_from_worker">
                                </gofix-form-input-textarea>
                            </b-col>
                        </b-row>
                        <!-- <gofix-form-input-textarea
                            label="Comment"
                            :rows="5"
                            v-model="modals.add.data.comment">
                        </gofix-form-input-textarea> -->
                        <dropdown-companies 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            required
                            show-icon-required
                            v-model="modals.add.data.company">
                        </dropdown-companies>
                        <!-- <dropdown-user-duties 
                            :project-id="modals.add.data.project && modals.add.data.project.id ? modals.add.data.project.id : null"
                            :company-id="modals.add.data.company && modals.add.data.company.id ? modals.add.data.company.id : null"
                            role-name="Contractor Supervisor"
                            v-model="modals.add.data.contractor_supervisor_by">
                        </dropdown-user-duties> -->

                        <gofix-form-input-date
                            :minDate="new Date()"
                            required
                            show-icon-required
                            v-model="modals.add.data.planned_date"
                            label="Date">
                        </gofix-form-input-date>
                        <b-row>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="Start Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.start_time">
                                </gofix-form-input-time>
                            </b-col>
                            <b-col md="6">
                                <gofix-form-input-time 
                                    label="End Time" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.end_time">
                                </gofix-form-input-time>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
import DropdownProjects from '../elements/DropdownProjects.vue'
import DropdownLocations from '../elements/DropdownLocations.vue'
import DropdownCompanies from '../elements/DropdownCompanies.vue'
import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
export default {
    name: 'toolbox-meeting-listing',
    components: {
        DropdownProjects,
        DropdownLocations,
        DropdownCompanies,
        DropdownUserDuties
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['toolbox_meeting_listing']));
        return {
            tableConfig:{
                name: 'safety-toolbox-meeting-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.toolbox_meeting, 'create'),
                    delete: this.$checkRole(this.$accessModule.toolbox_meeting, 'delete'),
                    tableImport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Submitted', text: 'Submitted'},
                            {value: 'Rejected', text: 'Rejected'},
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        project: null,
                        equipment: null,
                        checklist_template_id: null,
                        planned_date: null,
                        start_time: null,
                        end_time: null,
                        company: null,
                        // contractor_supervisor_by: null,
                        topics: null,
                        work_tasks: null,
                        work_tasks_other_text: null,
                        hazards: null,
                        hazards_other_text: null,
                        safe_work_procedures: null,
                        safe_work_procedure_other_text: null,
                        work_task_for_the_day: null,
                        hazards_identified: null,
                        mitigation_of_hazard: null,
                        feedback_from_worker: null,
                        comment: null,
                        // locations: null
                    },
                    options: {
                        topics: [],
                        work_tasks: [],
                        hazards: [],
                        safe_work_procedures: [],
                    }
                }
            },
            timer: {
                save: null
            },
        }
    },
    computed: {
        isUpsertLocation() {
            if(this.modals.add.data.project && this.modals.add.data.project.id && this.modals.add.data.project.contract_title == 'Lift Repair / Lift Maintenance') {
                return true
            }
            return false
        }
    },
    watch: {
        "modals.add.data.project": function(val, oldVal) {
            const newId = val && val.id ? val.id : null
            const oldId = oldVal && oldVal.id ? oldVal.id : null
            // Only clear dependent fields when the selected project actually changes
            if (newId === oldId) return

            this.modals.add.data.equipment = null
            this.modals.add.data.company = null
            // this.modals.add.data.contractor_supervisor_by = null
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getSafetyToolboxMeetingItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },
        changeProject() {
            this.modals.add.options.contractor_supervisors = [];
            // this.modals.add.data.contractor_supervisor_by = null;
            if(this.modals.add.data.project && this.modals.add.data.project.id) {
                this.getContractorSupervisors();
            }
        },
        clickToRowItem(item) {
           this.$router.push(`/v2/toolbox-meeting/${item.id}`)
        },
        newItem() {
            this.getTopics();
            this.getWorkTasks();
            this.getHazards();
            this.getSafeWorkProcedure();
            this.modals.add.data = {
                project: null,
                equipment: null,
                checklist_template_id: null,
                planned_date: null,
                start_time: null,
                end_time: null,
                company: null,
                // contractor_supervisor_by: null,
                topics: null,
                work_tasks: null,
                work_tasks_other_text: null,
                hazards: null,
                hazards_other_text: null,
                safe_work_procedures: null,
                safe_work_procedure_other_text: null,
                work_task_for_the_day: null,
                hazards_identified: null,
                mitigation_of_hazard: null,
                feedback_from_worker: null,
                comment: null,
            };
            this.modals.add.loading = false;
            this.modals.add.open = true;
            this.$nextTick(() => {
                if (this.$refs.dropdownProjects) {
                    this.$refs.dropdownProjects.getOptions('', true)
                }
            })
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetyToolboxMeetingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'toolbox_meeting'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems(tableRequest) {
            let request = JSON.parse(JSON.stringify(tableRequest));
            request.limit = -1;
            this.$store.dispatch('SafetyAppController/exportSafetyToolboxMeetings', request)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ToolboxMeetings.xlsx');
                document.body.appendChild(link);
                link.click();
            })
        },
        getTopics(){
            let filter = {reference_type: "Safety Toolbox Meeting Topics"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.topics = response.items;
                })
        },
        getWorkTasks(){
            let filter = {reference_type: "Safety Toolbox Meeting Work Tasks"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.work_tasks = response.items;
                })
        },
        getHazards(){
            let filter = {reference_type: "Safety Toolbox Meeting Hazards"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.hazards = response.items;
                })
        },
        getSafeWorkProcedure(){
            let filter = {reference_type: "Safety Toolbox Meeting Safe Work Procedure"};
            let params = {
                filter: filter,
                limit: -1,
                sortColumn: "id",
                sortDirection: "asc",
            };
            this.$store.dispatch(`ReferenceController/getItems`, params)
                .then(response => {
                    this.modals.add.options.safe_work_procedures = response.items;
                })
        },
        hasOthers(items) {
            return !!(items && items.some(item => item && item.reference_value_text === 'Others'));
        },
        splitOthersLines(otherText) {
            return (otherText || '').split('\n').map(line => line.trim()).filter(line => line.length);
        },
        hasOthersTextMissing(items, otherText) {
            return this.hasOthers(items) && this.splitOthersLines(otherText).length === 0;
        },
        buildSelectionsPayload(items, referenceType, otherText) {
            if (!items) return [];
            const lines = this.splitOthersLines(otherText);
            return items.reduce((acc, item) => {
                if (item.reference_value_text === 'Others') {
                    lines.forEach(line => {
                        acc.push({
                            id: item.id,
                            reference_type: referenceType,
                            reference_value_text: item.reference_value_text,
                            other_text: line,
                        });
                    });
                } else {
                    acc.push({
                        id: item.id,
                        reference_type: referenceType,
                        reference_value_text: item.reference_value_text,
                        other_text: null,
                    });
                }
                return acc;
            }, []);
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                const validate_fields = [
                    { key: 'project', name: 'Project'},
                    // { key: 'locations', name: 'Locations'},
                    { key: 'equipment', name: 'Location'},
                    { key: 'work_tasks', name: 'Work Tasks'},
                    { key: 'hazards', name: 'Hazards'},
                    { key: 'safe_work_procedures', name: 'Safe Work Procedure'},
                    { key: 'company', name: 'Subcontractor'},
                    { key: 'planned_date', name: 'Date'},
                    { key: 'start_time', name: 'Start Time'},
                    { key: 'end_time', name: 'End Time'},
                    
                ]

                const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                if(is_validate) return

                if(this.hasOthersTextMissing(this.modals.add.data.work_tasks, this.modals.add.data.work_tasks_other_text)) {
                    this.$alertNotification("Please specify Work Tasks (Others)", "danger");
                    return;
                }
                if(this.hasOthersTextMissing(this.modals.add.data.hazards, this.modals.add.data.hazards_other_text)) {
                    this.$alertNotification("Please specify Hazards (Others)", "danger");
                    return;
                }
                if(this.hasOthersTextMissing(this.modals.add.data.safe_work_procedures, this.modals.add.data.safe_work_procedure_other_text)) {
                    this.$alertNotification("Please specify Safe Work Procedure (Others)", "danger");
                    return;
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    client_contract_id: this.modals.add.data.project.client_contract_id,
                    project_id: this.modals.add.data.project.id,
                    location_id: this.modals.add.data.equipment.location_id,
                    location: this.modals.add.data.equipment.name,
                    // equipment_id: this.modals.add.data.equipment.equipment_id,
                    // equipment_lift_number: this.modals.add.data.equipment.equipment_lift_number,
                    // equipment_type: this.modals.add.data.equipment.equipment_type,
                    // topics: this.modals.add.data.topics,
                    supplier_id: this.modals.add.data.company && this.modals.add.data.company.id ? this.modals.add.data.company.id : null,
                    supplier: this.modals.add.data.company && this.modals.add.data.company.name ? this.modals.add.data.company.name : null,
                    // contractor_supervisor_id: this.modals.add.data.contractor_supervisor_by ? this.modals.add.data.contractor_supervisor_by.user_id : null,
                    planned_date: this.modals.add.data.planned_date ? moment(this.modals.add.data.planned_date).format('YYYY-MM-DD') : null,
                    start_time: this.modals.add.data.start_time ? this.modals.add.data.start_time : null,
                    end_time: this.modals.add.data.end_time ? this.modals.add.data.end_time : null,
                    // comment: this.modals.add.data.comment ? this.modals.add.data.comment : null,
                    work_tasks: this.buildSelectionsPayload(this.modals.add.data.work_tasks, 'Safety Toolbox Meeting Work Tasks', this.modals.add.data.work_tasks_other_text),
                    hazards: this.buildSelectionsPayload(this.modals.add.data.hazards, 'Safety Toolbox Meeting Hazards', this.modals.add.data.hazards_other_text),
                    safe_work_procedures: this.buildSelectionsPayload(this.modals.add.data.safe_work_procedures, 'Safety Toolbox Meeting Safe Work Procedure', this.modals.add.data.safe_work_procedure_other_text),
                    work_task_for_the_day: this.modals.add.data.work_task_for_the_day,
                    hazards_identified: this.modals.add.data.hazards_identified,
                    mitigation_of_hazard: this.modals.add.data.mitigation_of_hazard,
                    feedback_from_worker: this.modals.add.data.feedback_from_worker,
                    // locations: this.modals.add.data.locations ? this.modals.add.data.locations : null
                };
                
                this.$store.dispatch("SafetyAppController/createSafetyToolboxMeetingItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    await this.$router.push(`/v2/toolbox-meeting/${response.id}`)
                    await this.$alertNotification(this.$notificationV2('adding', 'toolbox_meeting'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        setDefaultProject(val) {
            // Only apply default when opening/empty — do not overwrite user selection
            if (!this.modals.add.data.project) {
                this.modals.add.data.project = val
            }
        },
    },
    created() {
        // Component lifecycle hook for initialization
    }
}
</script>

<style scoped>
.safety-inspection-checklist {
    padding: 20px;
}
</style>